export const formatNorwegianDate = (dateString: string): string =>
  new Intl.DateTimeFormat('no', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(dateString))
